module.exports = __webpack_public_path__ + "assets/not-data.429b806a.svg";